module.exports = __webpack_public_path__ + "d737b99282009ed904d46b95d97ef784.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/wing-4.png
// module id = 3016
// module chunks = 0